import { useTranslation } from 'react-i18next';

import './LoadButton.scss';

interface Props {
  hasNext: boolean;
  hasPrev: boolean;
  onClick: (direction: string) => void;
}

const LoadButton: React.FC<Props> = ({ hasNext, hasPrev, onClick }) => {
  const { t } = useTranslation();
  if (!hasNext && !hasPrev) {
    return <></>;
  }

  if (hasPrev) {
    return (
      <div className="show-more flex justify-center">
        <p
          className="load-button"
          onClick={() => {
            onClick('back');
          }}
        >
          {t('common:show_less')}
        </p>
      </div>
    );
  }

  return (
    <div className="show-more flex justify-center">
      <p
        className="load-button"
        onClick={() => {
          onClick('next');
        }}
      >
        {t('common:load_more')}
      </p>
    </div>
  );
};

export default LoadButton;
